import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SupervisionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12.0002 9.09107C11.3975 9.09107 10.9094 8.60291 10.9094 8.00022C10.9094 7.39753 11.3975 6.90937 12.0002 6.90937C12.6029 6.90937 13.0911 7.39753 13.0911 8.00022C13.0911 8.60291 12.6029 9.09107 12.0002 9.09107Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.1819 8C18.1819 8 15.6361 4 12.0002 4C8.32747 4 5.81852 8 5.81852 8C5.81852 8 7.63683 12 12.0002 12C16.3275 12 18.1819 8 18.1819 8ZM14.5453 8C14.5453 9.4181 13.4183 10.5451 12.0002 10.5451C10.5821 10.5451 9.45514 9.4181 9.45514 8C9.45514 6.5819 10.5821 5.45493 12.0002 5.45493C13.4183 5.45493 14.5453 6.5819 14.5453 8Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.633 14.0054L12.3695 14.0045L12.3753 18.5673L14.4744 16.4719L15.005 17.0011L12.0088 20.0049L9.00501 17.0087L9.53428 16.4781L11.6387 18.5683L11.633 14.0054Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.861 12.3817L16.3818 11.8609L19.6082 15.0874L19.6146 12.1213L20.364 12.1213V16.364L16.1214 16.364V15.6145L19.0874 15.6082L15.861 12.3817Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.10358 11.8614L7.62438 12.3822L4.39794 15.6086L7.36398 15.615L7.36398 16.3644H3.12134L3.12134 12.1218H3.87079L3.87714 15.0878L7.10358 11.8614Z'
                fill='currentColor'
            />
        </>
    ),
})

SupervisionIcon.displayName = 'SupervisionIcon'
